import { environment } from '@environments/environment';

/**
 * Fallback de lançamento AVD para módulos do workspace laboratorial quando NÃO há template
 * no catálogo (SUBMODULO_LANCAMENTO_EXTERNO) e `externalLaunchUrlsFromApiOnly === false`.
 *
 * Vem do AMBIENTE (antes era hardcoded para produção, o que jogava usuários de DEV para o AVD
 * de PROD): DEV/local apontam para o AVD de DEV (workspace WS-AVD `0a4eee1d`); PROD/HML mantêm o
 * workspace de produção. Em prod/hml `externalLaunchUrlsFromApiOnly === true`, então este
 * fallback nem chega a ser usado.
 */
export const WORKSPACE_LAB_AVD_BASE_URL = environment.avdWorkspaceLabBaseUrl;
